export const questionActionTypes = {
  REAL_BENEFICIARY: "BEN_REAL"
};
